import { useEffect, useEffectEvent } from 'react';
import { PdfProcessedEvent } from 'types/pushNotifications';

type PdfProcessedEventListener = (event: PdfProcessedEvent) => void | Promise<void>;

const listeners = new Set<PdfProcessedEventListener>();

export const emitPdfProcessedEvent = async (event: PdfProcessedEvent) => {
  await Promise.all([...listeners].map((listener) => listener(event)));
};

export const usePdfProcessedEvent = (onPdfProcessed: PdfProcessedEventListener) => {
  const notify = useEffectEvent(onPdfProcessed);

  useEffect(() => {
    const listener = (event: PdfProcessedEvent) => notify(event);
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  }, []);
};
